import { createSlice } from "@reduxjs/toolkit";
import updateProfileApi from "@custom/rtk-apis/user/updateProfie";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const updateProfileSlice = createSlice({
    name: "updateProfileSlice",
    initialState,
    reducers: {
        updateProfileRequest: (state) => {
            state.loading = true;
            state.error = null;
        },
        updateProfileSuccess: (state, action) => {
            state.status = 'SUCCESS';
            state.msg = action.payload.msg;
            state.result = action.payload.result;
            state.loading = false;
        },
        updateProfileFailure: (state, action) => {
            state.status = 'ERROR';
            state.msg = action.payload.msg;
            state.error = action.payload.error;
            state.loading = false;
        },
        resetUpdateProfileStatus: (state) => {
            state.status = '';
            state.msg = '';
            state.result = null;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(updateProfileApi.pending, (state, action) => {
                console.log("Pending")
                state.loading = true;
            })
            .addCase(updateProfileApi.fulfilled, (state, { payload }) => {
                console.log("Fulfilled", payload)
                state.loading = false;
                state.status = payload.status;
                state.result = payload.result;
                state.msg = payload.msg;
            })
            .addCase(updateProfileApi.rejected, (state, { payload }) => {
                console.log("Rejected")
                state.result = payload;
                state.loading = false;
            });
    },
});

export const {
    updateProfileRequest,
    updateProfileSuccess,
    updateProfileFailure,
    resetUpdateProfileStatus,
} = updateProfileSlice.actions;

export default updateProfileSlice.reducer;
